import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-light" }, "Results", -1)
const _hoisted_2 = { class: "relative pt-1" }
const _hoisted_3 = { class: "py-2 flex flex-row justify-between w-1/3" }
const _hoisted_4 = { class: "flex space-x-3 items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  style: { fill: '#FFAC66' },
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.018a2 2 0 01.485.06l3.76.94m-7 10v5a2 2 0 002 2h.096c.5 0 .905-.405.905-.904 0-.715.211-1.413.608-2.008L17 13V4m-7 10h2m5-10h2a2 2 0 012 2v6a2 2 0 01-2 2h-2.5"
  })
], -1)
const _hoisted_6 = { class: "mx-auto my-auto bg-gray-100 text-gray-400 rounded-xl p-1 text-sm" }
const _hoisted_7 = { class: "flex space-x-3 items-center mx-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 fill-primary",
  fill: "none",
  style: { fill: '#B1F68E' },
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
  })
], -1)
const _hoisted_9 = { class: "mx-auto my-auto bg-gray-100 text-gray-400 rounded-xl p-1 text-sm" }
const _hoisted_10 = { class: "flex space-x-3 items-center mx-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  width: "25",
  height: "25",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "15",
    cy: "15",
    r: "14",
    fill: "#339801",
    stroke: "black",
    "stroke-width": "2"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.3079 4.65797C14.5645 4.0432 15.4355 4.0432 15.6921 4.65797L17.8937 9.93186C17.9962 10.1775 18.2214 10.3505 18.4852 10.3862L24.2876 11.1715C24.9378 11.2595 25.1695 12.081 24.6612 12.4958L20.1809 16.1518C19.9594 16.3326 19.86 16.6235 19.9244 16.902L21.3568 23.0919C21.5119 23.762 20.7583 24.27 20.1953 23.8748L15.4309 20.5309C15.1723 20.3494 14.8277 20.3494 14.5691 20.5309L9.8047 23.8749C9.24167 24.27 8.48807 23.7621 8.64315 23.0919L10.0755 16.902C10.1399 16.6235 10.0404 16.3326 9.81895 16.1518L5.3388 12.4958C4.83048 12.081 5.06222 11.2595 5.7124 11.1715L11.5148 10.3862C11.7786 10.3505 12.0038 10.1775 12.1063 9.93186L14.3079 4.65797Z",
    fill: "white",
    stroke: "black",
    "stroke-width": "2",
    "stroke-miterlimit": "3.3292",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_12 = { class: "mx-auto my-auto bg-gray-100 text-gray-400 rounded-xl p-1 text-sm" }
const _hoisted_13 = { class: "flex flex-row justify-between w-full space-x-3 items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "0%", -1)
const _hoisted_15 = { class: "overflow-hidden mb-4 text-sm flex rounded bg-amber-200 h-8 w-full" }
const _hoisted_16 = {
  key: 0,
  style: { width: `${100}%` },
  class: "shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-gray-400 font-bold"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "100%", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(`${_ctx.bad}%`), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, _toDisplayString(`${_ctx.good}%`), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, _toDisplayString(`${_ctx.excellent}%`), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          (_ctx.excellent === 0 && _ctx.good === 0 && _ctx.bad === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Please, fill the evaluation "))
            : _createCommentVNode("", true),
          (_ctx.bad > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                style: _normalizeStyle({ width: `${_ctx.bad}%`, backgroundColor: '#FFAC66' }),
                class: "shadow-none flex flex-col text-center whitespace-nowrap text-gray-800 justify-center font-bold"
              }, " Not a fit ", 4))
            : _createCommentVNode("", true),
          (_ctx.good > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                style: _normalizeStyle({ width: `${_ctx.good}%`, backgroundColor: '#B1F68E' }),
                class: "shadow-none flex flex-col text-center whitespace-nowrap text-gray-800 justify-center border-l-4 border-white border-r-4 font-bold"
              }, " Moderate ", 4))
            : _createCommentVNode("", true),
          (_ctx.excellent > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                style: _normalizeStyle({ width: `${_ctx.excellent}%`, backgroundColor: '#339801' }),
                class: "shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center font-bold"
              }, " Strong ", 4))
            : _createCommentVNode("", true)
        ]),
        _hoisted_17
      ])
    ])
  ], 64))
}